import { render, staticRenderFns } from "./CmgLoyaltyProgressWallet.vue?vue&type=template&id=d13d707c&scoped=true&lang=pug&"
import script from "./cmg-loyalty-progress-wallet.ts?vue&type=script&lang=ts&"
export * from "./cmg-loyalty-progress-wallet.ts?vue&type=script&lang=ts&"
import style0 from "./CmgLoyaltyProgressWallet.vue?vue&type=style&index=0&id=d13d707c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13d707c",
  null
  
)

export default component.exports